import { get } from './Action';
import { queryPathBuilder } from '../../util/queryPathBuilder';
import {
  GET_ALL_DAILY_CASH_CLOSING_CASH,
  GET_ALL_DAILY_CASH_CLOSING_CASH_BY_BRANCH,
} from '../types';

const basePath = '/daily-cash-closing-cash';

export const getDailyCashClosingCash = (params) => async (dispatch) => {
  const queryParams = queryPathBuilder(params);
  return await dispatch(
    get(`${basePath}${queryParams}`, getDailyCashClosingCashDS, true)
  );
};

export const getDailyCashClosingCashByBranch =
  (branchId, { params }) =>
  async (dispatch) => {
    const queryParams = queryPathBuilder(params);
    return await dispatch(
      get(
        `${basePath}/${branchId}${queryParams}`,
        getDailyCashClosingCashByBranchDS
      )
    );
  };

const getDailyCashClosingCashDS = (dailyCashClosingCash) => ({
  type: GET_ALL_DAILY_CASH_CLOSING_CASH,
  payload: dailyCashClosingCash.items,
});

const getDailyCashClosingCashByBranchDS = (dailyCashClosing) => ({
  type: GET_ALL_DAILY_CASH_CLOSING_CASH_BY_BRANCH,
  payload: dailyCashClosing.items,
});
